var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 13.9998C8.16667 15.2885 7.122 16.3332 5.83333 16.3332C4.54467 16.3332 3.5 15.2885 3.5 13.9998C3.5 12.7112 4.54467 11.6665 5.83333 11.6665C7.122 11.6665 8.16667 12.7112 8.16667 13.9998Z",
    fill: "#151C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 13.9998C16.3333 15.2885 15.2887 16.3332 14 16.3332C12.7113 16.3332 11.6667 15.2885 11.6667 13.9998C11.6667 12.7112 12.7113 11.6665 14 11.6665C15.2887 11.6665 16.3333 12.7112 16.3333 13.9998Z",
    fill: "#151C22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 16.3332C23.4553 16.3332 24.5 15.2885 24.5 13.9998C24.5 12.7112 23.4553 11.6665 22.1667 11.6665C20.878 11.6665 19.8333 12.7112 19.8333 13.9998C19.8333 15.2885 20.878 16.3332 22.1667 16.3332Z",
    fill: "#151C22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.9785a863.svg";
export { ForwardRef as ReactComponent };